import request from 'tools/request'

export const getEmailAccountsList = async (params?: any) => {
  const res = await request.get(`${process.env.REACT_APP_CARRIER_API_URL}carrieremailaccount/list`, {
    params: {
      ...params,
      // companyId: 3151
    },
  })
  return res?.data
}

/**Paylod = {senderName, senderEmail, id:null, companyId: 3151} */
export const addEmailAccount = async (payload: any) => {
  const res = await request.post(`${process.env.REACT_APP_CARRIER_API_URL}carrieremailaccount/add`, {
    companyId: 3151,
    ...payload,
  })
  return res?.data
}

export const updateEmailAccount = async (payload: any) => {
  const res = await request.post(`${process.env.REACT_APP_CARRIER_API_URL}carrieremailaccount/update`, {
    companyId: 3151,
    ...payload,
  })
  return res?.data
}

export const getCarrierAccountList = async () => {
  const res = await request.get(`${process.env.REACT_APP_CARRIER_API_URL}carrieremailaccount/list/verified`)
  return res?.data
}
